import React from "react";
import { PropTypes } from "prop-types";
// Modern imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import Grid from "@limitless/modern/layout/Grid";
import Button from "@limitless/modern/inputs/button/Button";

const ModernTaskListFiltersHeader = ({ disabled, onClick, ...rest }) => {
    return (
        <Grid container direction={"row"} justifyContent={"space-between"} alignItems={"center"} paddingRight={2}>
            <Typography variant="subtitle1">{"Filters"}</Typography>
            <Button variant="text" size="small" onClick={onClick} disabled={disabled}  {...rest} style={{padding:0}}>
                {"Clear All"}
            </Button>
        </Grid>
    );
};

export default ModernTaskListFiltersHeader;

ModernTaskListFiltersHeader.propTypes = {
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};
